import axios from 'axios';
import toCamelCase from '@/helpers/toCamelCase';
import cloneDeep from 'lodash/cloneDeep';

export const state = () => ({
    items: [],
    promises: {}
});

export const getters = {
    items: state => state.items,
    promises: state => state.promises,
};

export const mutations = {
    SET_ITEM(state, item) {
        const index = state.items.findIndex(i => i.identityId === item.identityId);
        if (index >= 0) {
            state.items.splice(index, 1, cloneDeep(item));
        } else {
            state.items.push(item);
        }
    },

    SET_PROMISE(state, { id, promise }) {
        state.promises[id] = promise;
    },
};

export const actions = {
    async getItem({ commit, getters }, { id }) {
        let promise = getters.promises[id];

        const item = getters.items.find(i => `${i.identityId}` === `${id}`);
        if (item) {
            promise = new Promise(resolve => resolve(item));
        }

        if (promise === undefined) {
            promise = new Promise(
                (resolve, reject) => {
                    axios
                        .$get(`/v1/identities/${id}`)
                        .then((item) => {
                            commit('SET_ITEM', toCamelCase(item));
                            resolve(toCamelCase(item));
                        })
                        .catch((e) => reject(e))
                        .finally(() => commit('SET_PROMISE', { id, undefined }));
                }
            );

            commit('SET_PROMISE', { id, promise });
        }

        return promise;
    }
};
